import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { FullScreenMessage } from '@/components/ui/FullScreenMessage';
import { Button } from '@/components/ui/Button';
import { Spinner } from '@/components/ui/Spinner';
import { useAuth } from './AuthProvider';

/**
 * שומר מסלול: מסכי ניהול מוצגים רק אחרי שה-Worker אישר שהמשתמש מנהל.
 * זו שכבת נוחות בלבד — האבטחה האמיתית היא בשרת ובכללי Firestore.
 */
export function RequireAdmin() {
  const { status, retry, signOut } = useAuth();
  const location = useLocation();

  if (status.kind === 'initializing' || status.kind === 'verifying') {
    return (
      <FullScreenMessage title={status.kind === 'verifying' ? 'מאמתים הרשאות' : 'טוען'}>
        <Spinner />
      </FullScreenMessage>
    );
  }

  if (status.kind === 'error') {
    return (
      <FullScreenMessage title="לא הצלחנו לאמת את ההרשאה" body={status.message}>
        <div className="flex gap-3">
          <Button onClick={retry}>ניסיון חוזר</Button>
          <Button variant="secondary" onClick={() => void signOut()}>
            יציאה
          </Button>
        </div>
      </FullScreenMessage>
    );
  }

  if (status.kind === 'signed_out') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
